"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M8.78777 2.62488C9.45721 1.95544 10.5371 1.94992 11.212 2.62488L17.375 8.78789C18.0445 9.45733 18.05 10.5372 17.375 11.2122L11.212 17.3752C10.5426 18.0446 9.46273 18.0501 8.78777 17.3752L2.62476 11.2122C1.95532 10.5427 1.9498 9.46285 2.62476 8.78789L8.78777 2.62488ZM9.21964 13.5565C9.21964 14.0353 9.60803 14.4244 10.0871 14.4244C10.5661 14.4244 10.9545 14.0353 10.9545 13.5565C10.9545 13.0777 10.5661 12.6895 10.0871 12.6895C9.60803 12.6895 9.21964 13.0777 9.21964 13.5565ZM10.9545 10.9548V6.61729C10.9545 6.14022 10.5642 5.74998 10.0871 5.74998C9.60994 5.74998 9.21964 6.14022 9.21964 6.61729V10.9548C9.21964 11.4319 9.60994 11.8221 10.0871 11.8221C10.5642 11.8221 10.9545 11.4319 10.9545 10.9548Z",
    fill: "#727B7F"
  }));
};